
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetovijayawadacab() {



    const cardData =
    {
        keyword: ' Pune to Vijayawada Cabs',
        heading: 'Prince Cabs: Pune to Vijayawada Cabs',
        headingDescription: 'Prince Cabs provides dependable Pune to Vijayawada Cabs, ideal for business travel, family trips, pilgrimages, and long-distance journeys. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe, comfortable, and affordable ride from Pune to Vijayawada. With professional chauffeurs, flexible schedules, and on-time pickups, we make interstate travel hassle-free and convenient. Enjoy reliability, comfort, and trusted service with Prince Cabs’ dedicated cab service from Pune to Vijayawada..',

        top: 'Top Places to Visit in Vijayawada with Prince Cabs',

"topPlaces": [
  {
    "title": "Kanaka Durga Temple",
    "description": "Kanaka Durga Temple, located on Indrakeeladri Hill, is the most revered spiritual landmark of Vijayawada. Dedicated to Goddess Kanaka Durga, it attracts thousands of devotees daily, especially during Dasara celebrations. The temple offers panoramic views of the Krishna River. Its mythology links the goddess to the slaying of demon Mahishasura. The temple’s grandeur, spiritual energy, and location make it the city’s prime attraction. Pilgrims consider it a must-visit holy shrine."
  },
  {
    "title": "Prakasam Barrage",
    "description": "Prakasam Barrage is a striking landmark built across the Krishna River, connecting Vijayawada with Guntur. Stretching over 1.2 km, it regulates water flow and serves as a road bridge. At night, the barrage is illuminated, creating a spectacular view. It is also a popular hangout for locals to enjoy cool breezes and riverfront scenery. Photographers love capturing its grandeur. The barrage is both an engineering marvel and a leisure spot."
  },
  {
    "title": "Undavalli Caves",
    "description": "Undavalli Caves, carved out of solid sandstone, are ancient rock-cut temples dating back to the 4th–5th century. The caves feature a massive reclining statue of Lord Vishnu and showcase Gupta-era architecture. The site reflects the blend of Hindu and Buddhist influences. Surrounded by lush greenery and overlooking the Krishna River, it offers a peaceful setting. History buffs admire its carvings and rock artistry. It is a heritage gem near Vijayawada."
  },
  {
    "title": "Bhavani Island",
    "description": "Bhavani Island, situated on the Krishna River, is one of the largest river islands in India. Spread over 130 acres, it is a hub for water sports, resorts, and adventure activities. Visitors enjoy boat rides, kayaking, and camping amidst nature. The island is also known for eco-tourism and leisure resorts. Families and couples love its scenic and recreational vibe. Bhavani Island is Vijayawada’s ultimate weekend escape."
  },
  {
    "title": "Mangalagiri Temple",
    "description": "Mangalagiri Temple, dedicated to Lord Narasimha, is located on a hill about 12 km from Vijayawada. The temple is unique because the deity is believed to consume panakam (jaggery water) offered by devotees. Its architecture, mythological tales, and annual festivals attract pilgrims from far and wide. The temple complex is surrounded by scenic hills. It holds great significance in South India’s spiritual circuit. Mangalagiri adds devotional depth to Vijayawada tourism."
  },
  {
    "title": "Victoria Museum",
    "description": "Victoria Jubilee Museum, also called Bapu Museum, is a heritage museum in Vijayawada. Built in 1887, it showcases sculptures, paintings, coins, weapons, and artifacts from different eras. The museum has a strong collection of Buddhist relics and Hindu deities. Its Indo-European architectural style adds to the charm. It educates visitors about Andhra Pradesh’s rich culture and history. It is a must-visit for art and heritage lovers."
  },
  {
    "title": "Kondapalli Fort",
    "description": "Kondapalli Fort, located 16 km from Vijayawada, is a historic fort built in the 14th century by the Reddy dynasty. The fort served as a military outpost and later as a training center for British soldiers. Its three majestic gates, ruins, and panoramic views of the hills attract visitors. Kondapalli is also famous for wooden toys crafted by local artisans. The fort combines history, culture, and tradition in one experience. It is a unique heritage site near the city."
  },
  {
    "title": "Rajiv Gandhi Park",
    "description": "Rajiv Gandhi Park is a well-maintained urban park located at the entrance of Vijayawada city. It features landscaped gardens, musical fountains, and a mini-zoo. The park is popular among families for picnics and evening walks. Children enjoy the play areas and amusement rides. Seasonal flower shows add vibrancy to the park. It is one of Vijayawada’s most loved recreational spots."
  },
  {
    "title": "Mogalarajapuram Caves",
    "description": "Mogalarajapuram Caves are ancient rock-cut caves dating back to the 5th century. They are known for their idols of Lord Nataraja, Vinayaka, and Ardhanareeshwara, which are rare in South India. Although partially ruined, the caves still reflect remarkable craftsmanship. Historians believe they were associated with early Hindu worship. Surrounded by natural beauty, they are a peaceful heritage site. The caves remain a hidden gem of Vijayawada."
  },
  {
    "title": "Gandhi Hill",
    "description": "Gandhi Hill is a memorial built to honor Mahatma Gandhi, located near Vijayawada Railway Station. It features a 15.8-meter-high stupa and exhibits related to Gandhi’s life. The site also has a planetarium, library, and light-and-sound show. Visitors enjoy panoramic views of the city from the hilltop. It combines history, inspiration, and scenic beauty. Gandhi Hill is an iconic landmark spreading the message of peace and non-violence."
  }
],

     "services": [
    {
      "name": "Pune to Vijayawada Cabs Booking",
      "description": "Book comfortable and reliable cabs from Pune to Vijayawada with professional drivers, clean vehicles, and affordable rates. Enjoy a hassle-free journey whether for business or leisure."
    },
    {
      "name": "Pune to Visakhapatnam Cab",
      "description": "Travel from Pune to Visakhapatnam in style and comfort with our trusted cab services offering a range of vehicles including Innova and Dzire for your convenience."
    },
    {
      "name": "Pune to Tirupati Cab",
      "description": "Convenient and affordable taxi service from Pune to Tirupati for pilgrims and travelers. Choose from a variety of vehicles to suit your travel needs."
    },
    {
      "name": "Pune to Tirupati Innova Package",
      "description": "Exclusive Innova cab packages for Pune to Tirupati trips, perfect for families and groups looking for spacious and comfortable rides with experienced drivers."
    },
    {
      "name": "Pune to Mysore Ooty Cab Package",
      "description": "Explore the beautiful hill stations of Mysore and Ooty with our special cab packages from Pune. Enjoy scenic drives in comfortable Innova and Dzire taxis."
    },
    {
      "name": "Pune to Chittoor Cab",
      "description": "Reliable cab service from Pune to Chittoor with flexible booking options and professional drivers to ensure a smooth and safe journey."
    },
    {
      "name": "Pune to Tenali Cab",
      "description": "Affordable and punctual taxi services from Pune to Tenali with a fleet of well-maintained vehicles including sedans and SUVs."
    },
    {
      "name": "Pune to Nellore Taxi",
      "description": "Book a taxi from Pune to Nellore offering comfortable rides, competitive pricing, and excellent customer service for both one-way and round trips."
    },
    {
      "name": "Pune to Anantapur Cab",
      "description": "Travel comfortably from Pune to Anantapur with our reliable cab services featuring spacious vehicles and professional chauffeurs."
    },
    {
      "name": "Pune to Vijayawada Dzire Taxi",
      "description": "Economical Dzire taxi service from Pune to Vijayawada, ideal for small families or business travelers seeking comfort and affordability."
    },
    {
      "name": "Pune to Vijayawada Innova Cab",
      "description": "Premium Innova taxi service from Pune to Vijayawada offering luxury, space, and a smooth journey for groups and families."
    },
    {
      "name": "Pune to Vijayawada Round Trip Cab",
      "description": "Convenient round trip cab options from Pune to Vijayawada with flexible timings, experienced drivers, and well-maintained vehicles."
    },
    {
      "name": "Affordable Pune to Vijayawada Taxi",
      "description": "Budget-friendly taxi services from Pune to Vijayawada without compromising on safety and comfort, suitable for all traveler types."
    },
    {
      "name": "Luxury Cab Pune to Vijayawada",
      "description": "Experience premium luxury cab services from Pune to Vijayawada featuring high-end vehicles and exceptional customer care for a memorable trip."
    }
  ],
  "tableData": [
    ["Pune to Vijayawada Cabs Booking", "Pune to Visakhapatnam Cab"],
    ["Pune to Tirupati Cab", "Pune to Tirupati Innova Package"],
    ["Pune to Mysore Ooty Cab Package", "Pune to Chittoor Cab"],
    ["Pune to Tenali Cab", "Pune to Nellore Taxi"],
    ["Pune to Anantapur Cab", "Pune to Vijayawada Dzire Taxi"],
    ["Pune to Vijayawada Innova Cab", "Pune to Vijayawada Round Trip Cab"],
    ["Affordable Pune to Vijayawada Taxi", "Luxury Cab Pune to Vijayawada"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Vijayawada Cab Service",
        "WhyChoosedescription": "Prince Cabs offers dependable and comfortable cab services from Pune to Vijayawada, catering to business travelers, tourists, and families. Covering a long-distance journey of over 1,000 km, our service ensures safety, punctuality, and a hassle-free travel experience, making your trip enjoyable and stress-free."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles for Long Travel",
        "WhyChoosedescription": "Our fleet includes well-maintained sedans and SUVs such as Swift Dzire and Innova, all designed for maximum comfort on extended journeys. Spacious seating, ample legroom, and sufficient luggage space combined with air-conditioned cabins ensure a pleasant travel experience throughout the trip."
    },
    {
        "WhyChooseheading": "Experienced Drivers Skilled in Long-Distance Routes",
        "WhyChoosedescription": "Our professional drivers have extensive knowledge of the highways and routes between Pune and Vijayawada. They focus on safe driving, efficient route planning, and timely breaks, ensuring you reach your destination comfortably and on schedule."
    },
    {
        "WhyChooseheading": "Flexible Booking Options Tailored to Your Needs",
        "WhyChoosedescription": "Whether you require a one-way trip, round trip, or multi-day rental covering Vijayawada and nearby attractions, Prince Cabs offers customizable packages to fit your travel plans. Bookings can be made easily via phone, WhatsApp, or online with instant confirmation."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Our Pune to Vijayawada cab service features upfront, competitive pricing that includes fuel, tolls, driver allowances, and taxes. We offer multiple secure payment options including UPI, credit/debit cards, net banking, and cash, providing convenience and transparency."
    },
    {
        "WhyChooseheading": "Sanitized and Well-Maintained Vehicles for Your Safety",
        "WhyChoosedescription": "Each cab is thoroughly cleaned and sanitized before and after every trip to ensure a hygienic environment. Regular maintenance checks guarantee mechanical reliability, while essential safety features such as seat belts and airbags provide added protection."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Hassle-Free Travel",
        "WhyChoosedescription": "Our customer care team is available round the clock to assist with bookings, itinerary modifications, or any travel-related concerns. With Prince Cabs, enjoy a smooth, comfortable, and worry-free journey from Pune to Vijayawada."
    }
]






























    }

const faqData = [
    {
        question: 'Does Prince Cabs offer cab services from Pune to Vijayawada?',
        answer: 'Yes, Prince Cabs provides reliable and comfortable cab services from Pune to Vijayawada, suitable for business trips, family travel, and leisure.',
    },
    {
        question: 'What types of vehicles are available for Pune to Vijayawada trips?',
        answer: 'We offer a range of vehicles including Swift Dzire, Innova, and Tempo Traveller to accommodate solo travelers, families, and groups.',
    },
    {
        question: 'How long does the journey from Pune to Vijayawada take by cab?',
        answer: 'The travel time usually ranges from 18 to 22 hours depending on traffic and road conditions.',
    },
    {
        question: 'Can I book a round-trip cab from Pune to Vijayawada?',
        answer: 'Yes, Prince Cabs offers flexible one-way and round-trip packages tailored to your travel needs.',
    },
    {
        question: 'Are the cabs sanitized and well-maintained for long-distance travel?',
        answer: 'Yes, all our vehicles are regularly cleaned, sanitized, and serviced to ensure your safety and comfort during the journey.',
    },
    {
        question: 'What are the approximate fares for Pune to Vijayawada cab service?',
        answer: 'Fares vary based on the vehicle type, distance, and duration. Contact Prince Cabs for a personalized and competitive quote.',
    },
    {
        question: 'How do I book a cab from Pune to Vijayawada?',
        answer: 'You can easily book through our website or by calling our customer support with your travel details for quick confirmation.',
    },
];

const testimonials = [
    {
        name: "Mr. Arjun Reddy",
        position: "Business Traveler",
        text: "Prince Cabs provided excellent service from Pune to Vijayawada. The cab was comfortable and the driver professional.",
        image: "/img/testimonial/testimonial-thumb-vijayawada-1.png",
    },
    {
        name: "Ms. Kavya Iyer",
        position: "Family Traveler",
        text: "Our trip from Pune to Vijayawada was smooth and hassle-free with Prince Cabs. Highly recommend their services.",
        image: "/img/testimonial/testimonial-thumb-vijayawada-2.png",
    },
];


































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Vijayawada Cabs",
  "description": "Affordable and reliable cab services from Pune to Vijayawada, Visakhapatnam, Tirupati, Mysore, Ooty, Chittoor, and nearby cities. Options include Dzire, Innova cabs, round trip packages, and luxury tours.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Pune to Vijayawada Cabs Booking",
    "Pune to Visakhapatnam Cab",
    "Pune to Tirupati Cab",
    "Pune to Tirupati Innova Package",
    "Pune to Mysore Ooty Cab Package",
    "Pune to Chittoor Cab",
    "Pune to Tenali Cab",
    "Pune to Nellore Taxi",
    "Pune to Anantapur Cab",
    "Pune to Vijayawada Dzire Taxi",
    "Pune to Vijayawada Innova Cab",
    "Pune to Vijayawada Round Trip Cab",
    "Affordable Pune to Vijayawada Taxi",
    "Luxury Cab Pune to Vijayawada"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};





    return (
        <div>
<Helmet>
  <title>Pune to Vijayawada Cabs | Visakhapatnam, Tirupati Taxi Service</title>
  <meta
    name="description"
    content="Affordable and reliable cab services from Pune to Vijayawada, Visakhapatnam, Tirupati, Mysore, Ooty, Chittoor, and nearby cities. Book Dzire, Innova, round trip, and luxury cab packages."
  />
  <meta
    name="keywords"
    content="Pune to Vijayawada Cabs Booking, Pune to Visakhapatnam Cab, Pune to Tirupati Cab, Pune to Tirupati Innova Package, Pune to Mysore Ooty Cab Package, Pune to Chittoor Cab, Pune to Tenali Cab, Pune to Nellore Taxi, Pune to Anantapur Cab, Pune to Vijayawada Dzire Taxi, Pune to Vijayawada Innova Cab, Pune to Vijayawada Round Trip Cab, Affordable Pune to Vijayawada Taxi, Luxury Cab Pune to Vijayawada"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/51.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetovijayawadacab ;